import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import {clearDashboardAuth, isDashboardTokenValid} from "@/utils/dashboardAuth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/entitylink"
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      public: true,
      title: "登录"
    }
  },
  {
    path: "/entitylink",
    name: "EntityLink",
    component: () => import("@/views/EntityLink.vue"),
    meta: {
      require: false,
      title: "实体关联域名信息查询",
      screenFit: true
    }
  },
  {
    path: "/authrisk",
    name: "AuthRisk",
    component: () => import("@/views/AuthRisk.vue"),
    meta: {
      require: false,
      title: "权威侧域名配置与安全监控",
      screenFit: true
    }
  },
  {
    path: "/recrisk",
    name: "RecRisk",
    component: () => import("@/views/RecRisk.vue"),
    meta: {
      require: false,
      title: "递归域名解析监控",
      screenFit: true
    }
  },
  // 保留原有的工业大屏路由（如需要）
  {
    path: "/screen",
    name: "Screen",
    component: () => import("@/views/screen/index.vue"),
    meta: {
      require: false
    }
  },
  {
    path: "/status",
    name: "Status",
    component: () => import("@/views/Status.vue"),
    meta: {
      require: false,
      title: "服务状态"
    }
  },
  {
    path: "/authdep",
    name: "AuthDep",
    component: () => import("@/views/AuthDep.vue"),
    meta: {
      require: false,
      title: "授权依赖风险监测",
      screenFit: true
    }
  },
  {
    path: "/jobmanager",
    name: "JobManager",
    component: () => import("@/views/JobManager.vue"),
    meta: {
      require: false,
      title: "作业管理"
    }
  },
  {
    path: "/maliciousdomain",
    name: "MaliciousDomain",
    component: () => import("@/views/MaliciousDomain.vue"),
    meta: {
      require: false,
      title: "恶意域名检测",
      screenFit: true
    }
  },
  {
    path: "/resolverevolution",
    name: "ResolverEvolution",
    component: () => import("@/views/ResolverEvolution.vue"),
    meta: {
      require: false,
      title: "DNS解析器演化追踪",
      screenFit: true
    }
  },
  // 兜底：未匹配任何页面的路径走 404 页，避免刷新/手输错误路径时出现白屏
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/views/NotFound.vue"),
    meta: {
      require: false,
      title: "页面不存在"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
});

router.beforeEach((to, from, next) => {
  store.commit("auth/clearAxiosPromiseCancel");

  if (to.meta && to.meta.public) {
    if (to.path === "/login" && isDashboardTokenValid()) {
      const redirect = to.query && to.query.redirect ? String(to.query.redirect) : "/entitylink";

      next(redirect.startsWith("/login") ? "/entitylink" : redirect);
      return;
    }
    next();
    return;
  }

  if (!isDashboardTokenValid()) {
    clearDashboardAuth();
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
    return;
  }

  next();
});

router.onError(() => {
});

export default router;
